import * as React from "react";
import { get } from "lodash-es";
import Foundation from "@microsoft/fast-components-foundation-react";
/**
 * The SVGFoundation component is the component that all fast icon components are built on top of. It provides a common
 * set of utilities that each component inherits.
 * @param H - These are the props that are "handled". "handled" props are not mapped automatically to the root element
 * returned by the render function. Use handled props to expose inputs that will not map directly to DOM attributes
 * (eg a custom callback) or where the DOM attribute would be required.
 * @param U - These are "unhandled" props that map to SVGAttributes<SVGElement>. Any props from this interface will be mapped onto the root DOM node of the
 * render function as-is. It is advised that these props map to valid SVG attributes - otherwise you will likely have HTML errors.
 */
class SVGFoundation extends Foundation {
    renderTitleText(props) {
        return typeof get(props, "titleText") === "string" ? (React.createElement("title", null, get(props, "titleText"))) : null;
    }
}
SVGFoundation.defaultProps = {
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg",
};
export default SVGFoundation;
